module.exports = __webpack_public_path__ + "img/Olav_og_Kari_Ulike_balladetyper.20b346cd.jpg";